import { magicNumbers } from './magicNumbers';

/**
 * Platforms of a tab bar exactly in the order saved in settings: the bar's own
 * platforms, and the ones under "other platforms".
 *
 * Saved entries this page doesn't have are skipped, and platforms saved in
 * neither list go to the end of "other platforms". Only a user who has saved
 * nothing at all gets the default, the first MAX_VISIBLE_PLATFORM_TABS in the
 * bar. A user whose bar platforms don't exist on this page (e.g. only "all" is
 * left in the bar, on a page without it) gets an empty bar list, so every tab
 * keeps the saved "other platforms" order instead of falling back to defaults.
 *
 * @param {Object} params
 * @param {string[]} params.platforms Platforms this page can show, in default order
 * @param {string[]} [params.visiblePlatforms] Saved platforms of the bar
 * @param {string[]} [params.morePlatforms] Saved platforms of "other platforms"
 * @returns {{ visiblePlatforms: string[], morePlatforms: string[] }}
 */
export const orderPlatformTabs = ({
  platforms,
  visiblePlatforms,
  morePlatforms,
}) => {
  const hasSavedOrder = Boolean(
    visiblePlatforms?.length || morePlatforms?.length
  );
  const visible = hasSavedOrder
    ? (visiblePlatforms || []).filter((platform) =>
        platforms.includes(platform)
      )
    : platforms.slice(0, magicNumbers.MAX_VISIBLE_PLATFORM_TABS);
  const more = [...new Set([...(morePlatforms || []), ...platforms])].filter(
    (platform) => platforms.includes(platform) && !visible.includes(platform)
  );

  return { visiblePlatforms: visible, morePlatforms: more };
};
